import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import { store } from "./shared/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import "src/features/global/global";
import BrandStyleInjector from "src/shared/components/brand-theming/BrandStyleInjector";
import { setProjectOptions } from "./shared/project-options";
import { ProjectConfig } from "./shared/models/ProjectConfig";
import "./shared/locales/i18n";
// page config
import replaceBasketToInpage from "./features/home/util/replace-basket-to-inpage";
import hideBeforeMountLoader from "./shared/util/hide-before-mount-loader";
import { updateConfigFromPage } from "./shared/util/update-config-from-page";
import "react-spring-bottom-sheet/dist/style.css";
//setup dayjs
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
import "dayjs/locale/tr";
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.locale("tr");

interface ReactEntryProps {
  projectBrand: string;
}
const ReactEntry = ({ projectBrand }: ReactEntryProps) => {
  useEffect(() => {
    try {
      hideBeforeMountLoader();
      replaceBasketToInpage();
    } catch {}
  }, []);
  return (
    <React.StrictMode>
      <Provider store={store}>
        <BrandStyleInjector theme={projectBrand}>
          <App />
        </BrandStyleInjector>
      </Provider>
    </React.StrictMode>
  );
};

export default function LiveCommerceWidget(config: ProjectConfig) {
  const _config = updateConfigFromPage(config);
  setProjectOptions(_config);

  ReactDOM.render(
    <ReactEntry projectBrand={config?.options?.brand || ""} />,
    document.getElementById("lc-shop-root")
  );
}

if (process.env.NODE_ENV !== "production") {
  ReactDOM.render(
    <ReactEntry projectBrand="development" />,
    document.getElementById("development-root")
  );
}
serviceWorker.unregister();
